var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobilityStations({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "mobilityStations_svg__a",
    points: ".003 .315 233 .315 233 68.038 .003 68.038"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "mobilityStations_svg__c",
    points: "0 163.447 233 163.447 233 .66 0 .66"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44 76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .347)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mobilityStations_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mobilityStations_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M138.782 55.848h-5.545v-34.35c0-.456.014-.945.028-1.467.023-.522.056-1.053.102-1.598l-16.02 29.227c-.541.979-1.3 1.468-2.28 1.468h-.913c-.978 0-1.738-.49-2.283-1.468L95.496 18.335a30.098 30.098 0 01.195 3.164v34.349h-5.55V9.103h4.665c.568 0 1.002.052 1.31.163.302.108.596.415.88.914l16.147 28.77c.303.523.568 1.072.797 1.65.228.573.452 1.156.67 1.743.215-.61.444-1.188.686-1.743.238-.559.508-1.118.815-1.682l15.816-28.738c.285-.499.578-.806.886-.914.303-.111.736-.163 1.305-.163h4.664v46.745zM222.126.315H10.875C4.868.315.003 5.18.003 11.186v45.976c0 6.007 4.865 10.876 10.872 10.876h211.251c6.007 0 10.877-4.87 10.877-10.876V11.186c0-6.006-4.87-10.871-10.877-10.871z",
    mask: "url(#mobilityStations_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M194.816 127.037a5.296 5.296 0 01-5.294-5.294 5.296 5.296 0 0110.592 0 5.297 5.297 0 01-5.298 5.294m-61.6 0a5.292 5.292 0 01-5.29-5.294 5.292 5.292 0 015.29-5.294 5.297 5.297 0 015.298 5.294 5.297 5.297 0 01-5.299 5.294m62.971-17.06H131.85c-6.948 0-12.582 5.634-12.582 12.586v9.688c0 6.948 5.634 12.582 12.582 12.582h64.336c6.948 0 12.582-5.634 12.582-12.582v-9.688c0-6.952-5.634-12.586-12.582-12.586"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M189.655 109.423h-51.278c-1.18 0-1.971-1.575-1.491-2.978l5.41-15.914c.266-.769.853-1.262 1.496-1.262h40.453c.648 0 1.235.493 1.496 1.262l5.41 15.914c.48 1.403-.312 2.978-1.496 2.978m8.486-.116l-6.808-23.361c-.326-1.128-1.062-1.855-1.878-1.855h-50.873c-.816 0-1.552.727-1.878 1.855l-6.808 23.36c-.602 2.06.396 4.372 1.878 4.372h64.49c1.481 0 2.478-2.312 1.877-4.371"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131.638,
    x2: 131.638,
    y1: 139.288,
    y2: 153.71,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 13.98
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.4,
    x2: 196.4,
    y1: 139.288,
    y2: 153.71,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 13.98
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mobilityStations_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mobilityStations_svg__c"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "6.832 163.447 15.532 163.447 15.532 39.804 6.832 39.804",
    mask: "url(#mobilityStations_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "216.532 163.447 225.232 163.447 225.232 39.804 216.532 39.804",
    mask: "url(#mobilityStations_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M97.903 154.453c-8.085 0-14.67-6.58-14.67-14.665 0-4.818 2.344-9.087 5.942-11.762a275.827 275.827 0 007.004 12.736 1.693 1.693 0 002.325.596 1.703 1.703 0 00.596-2.325 274.54 274.54 0 01-6.985-12.717 14.531 14.531 0 015.788-1.198c8.085 0 14.665 6.58 14.665 14.67 0 8.085-6.58 14.665-14.665 14.665zm-32.196-17.4a5.112 5.112 0 00-2.027-.951l-5.518-19.917 25.537-.168c.368.998.788 2.046 1.254 3.146l-19.246 17.89zm-9.996-.336a18.853 18.853 0 00-3.653-8.462c-.065-.084-.126-.168-.191-.252l-2.773 3.695.168.257c1.002 1.57 1.747 3.322 2.092 5.223l-11.1 1.17 6.818-9.134 2.646-3.508-.014-.014 5.523-7.4 4.972 17.954-4.488.471zm42.192-15.984c-2.759 0-5.373.601-7.745 1.66-1.491-3.095-2.833-6.129-3.658-8.617-.96-2.861-1.766-6.263-2.2-8.09-.205-.862-.354-1.426-.414-1.57a4.599 4.599 0 00-4.45-2.936h-3.729c-.932 0-1.691.76-1.691 1.696 0 .937.76 1.692 1.691 1.692h3.803c.177.028.923.046 1.207.74.046.16.144.574.284 1.161.336 1.43.895 3.793 1.59 6.165l-24.96.163v-3.546c0-.154-.046-.294-.084-.438l.238-.047c.527-.33 1.342-.717 2.526-.899.932-.14 4.403-.979 4.375-2.493-.023-1.086-1.56-1.254-2.143-1.314-.531-.06-1.305-.168-2.214-.29-2.772-.381-6.561-.894-9.301-.894-2.25 0-3.365.34-3.728 1.142-.247.54-.08 1.146.49 1.799 2.203 2.497 4.892 3.313 6.453 3.592v4.53l-7.246 9.702a18.9 18.9 0 00-10.066-2.908c-10.508 0-19.059 8.547-19.059 19.055 0 10.504 8.551 19.05 19.06 19.05 7.605 0 14.166-4.483 17.213-10.946l-4.566-.774c-2.545 4.367-7.242 7.335-12.648 7.335-8.09 0-14.67-6.58-14.67-14.665 0-8.09 6.58-14.67 14.67-14.67 2.717 0 5.252.755 7.438 2.05l-8.85 11.856a1.707 1.707 0 00-.177 1.733c.266.564.82.942 1.445.974l.116.005-.027.028 14.054 2.4 4.339.74 5.82.998c.485.154.992.26 1.538.26a5.088 5.088 0 005.084-5.088c0-.387-.052-.764-.135-1.128l18.84-17.512c.252.531.513 1.072.769 1.608-5.033 3.434-8.342 9.213-8.342 15.746 0 10.504 8.547 19.05 19.06 19.05 10.504 0 19.05-8.546 19.05-19.05 0-10.508-8.546-19.055-19.05-19.055z",
    mask: "url(#mobilityStations_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 4.66,
    d: "M53.556 139.818c0 9.25-7.498 16.753-16.753 16.753-9.25 0-16.748-7.503-16.748-16.753s7.498-16.753 16.748-16.753c9.255 0 16.753 7.503 16.753 16.753z",
    mask: "url(#mobilityStations_svg__d)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilityStations);
export default __webpack_public_path__ + "static/media/mobilityStations.92e4a6d1.svg";
export { ForwardRef as ReactComponent };